import { render, staticRenderFns } from "./TabContent.vue?vue&type=template&id=b447c4be&scoped=true&"
import script from "./TabContent.vue?vue&type=script&lang=js&"
export * from "./TabContent.vue?vue&type=script&lang=js&"
import style0 from "./TabContent.vue?vue&type=style&index=0&id=b447c4be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b447c4be",
  null
  
)

export default component.exports